module.exports = __webpack_public_path__ + "static/media/SmartNewLoadingGray.cf13a6a3.svg";